import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { AdminsApi, Contact, ContactsApi, FindContactRequest, Person } from 'src/app/hickory-api';
import { FacilityDetailsDialogComponent } from '../facility-details-dialog/facility-details-dialog.component';
import { Observable } from 'rxjs';
import { ApiError } from 'src/app/shared/model/utility';

export interface ContactDetailsData  {
  title?: string;
  contactId?: number;
  adminId?: number;
  contact?: Contact;
}

@Component({
  selector: 'app-contact-details-dialog',
  templateUrl: './contact-details-dialog.component.html',
  styleUrls: ['./contact-details-dialog.component.scss'],
  standalone: false
})
export class ContactDetailsDialogComponent implements OnInit {
  contact: Contact;
  dialogTitle: string;
  loadError: string = null;
  hideRetry: boolean = false;

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    @Inject(MAT_DIALOG_DATA) public data: ContactDetailsData,
    private contactsApi: ContactsApi,
    private adminsApi: AdminsApi,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.contact = this.data.contact;
    this.dialogTitle = this.data.title ?? 'Contact Details';
    this.loadContact();
  }

  loadContact(useAdminApi = false) {
    if (this.contact) return;
    const request: FindContactRequest = { 
      contactIds: (this.data?.contactId) ? [this.data.contactId] : [],
      adminIds: (this.data?.adminId) ? [this.data.adminId] : undefined,
      includeAsset: true,
    };
    
    this.loadError = null;
    this.hideRetry = false;
    const rx: Observable<any> = useAdminApi ? this.adminsApi.getAdmins([this.data.adminId]) : this.contactsApi.findContacts(request);
    rx.subscribe({
      next: (res) => {
        // grab the first result, if present
        const item = res?.items?.find(_ => true);
        this.contact = this.convertIfNecessary(item);
        this.processResults(useAdminApi);
      },
      error: (err: ApiError) => {
        this.loadError = 'An error occurred retrieving contact details';
        if (err.status === 404) {
          this.processResults(useAdminApi);
        }
      }
    });
  }

  private convertIfNecessary(person: Person): Contact {
    if (!person?.name) return person;
    return {
      firstName: person?.name?.givenName,
      lastName: person?.name?.familyName,
    };
  }

  private processResults(fromAdminApi: boolean) {
    this.loadError = null;
    this.hideRetry = false;
    if (!this.contact) {
      if (!!this.data?.adminId && !fromAdminApi) {
        this.loadContact(true);
      } else {
        this.loadError = 'No details found for this contact';
        this.hideRetry = true;
      }
    }
  }

  loadAsset() {
    this.dialog.open(FacilityDetailsDialogComponent, {
      minWidth: '600px',
      data: { assetId: this.contact?.asset?.id, }
    });
  }

  closeDialogs() {
    this.dialog.closeAll();
  }

}
